/**
 * The A2 Easy brand mark — "Drievlag-trap": three ascending rounded bars in the
 * Dutch flag colours (blauw → wit → rood), reading as an upward staircase
 * (opstap) toward passing the exam. Inline SVG so we can size + retint at will.
 *
 * Kept under the historical name `Spreekballon` (the previous speech-balloon
 * glyph) to avoid churning every call site + the design-sync barrel; the glyph
 * itself is the new staircase mark. Flag colours are brand-fixed, not themed.
 * Square aspect ratio; pass `size` (px) and `tone` (default | inverse).
 */
export function Spreekballon({
  size = 40,
  tone = "default",
  className,
}: {
  size?: number;
  tone?: "default" | "inverse" | "accent";
  className?: string;
}) {
  const onDark = tone === "inverse";
  const blue = onDark ? "#5b8de0" : "#21468b";
  const red = onDark ? "#e23a52" : "#c8102e";
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="A2 Easy"
    >
      <rect x="13" y="55" width="20" height="32" rx="10" fill={blue} />
      <rect
        x="40"
        y="39"
        width="20"
        height="48"
        rx="10"
        fill="#ffffff"
        stroke={onDark ? "none" : "#e3ddd2"}
        strokeWidth="1.6"
      />
      <rect x="67" y="20" width="20" height="67" rx="10" fill={red} />
    </svg>
  );
}
